<template>
    <div>

        <div class="section bg-svg-rainoverforest2">
            <div class="overlay opacity-50"></div>

            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-5">Change Email</h1>

                        <p class="lead mb-5">Open Sleep Jar on your mobile device to manage these settings.</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
    export default {
        name: 'settings-email',
        metaInfo: {
            title: 'Change Email'
        },
        data () {
            return {
            };
        },
        methods: {
        },
        computed: {
        },
        components: {
        },
        mounted(){
        }
    }
</script>
